import { Action } from '@ngrx/store';

export const LOAD_COMPANY_INFO: string = '[Company Info] Load Company Info';
export const LOAD_COMPANY_INFO_SUCCESS: string = '[Company Info] Load Company Info Success';
export const LOAD_COMPANY_INFO_FAIL: string = '[Company Info] Load Company Info Fail';

export interface CompanyInfo {
  workspace_id: number;
  agency: {
    name: string;
    email: string;
    workspace_name: string;
    domain: string;
    currency: string;
    created_at: string;
    can_send_email: boolean;
  };
  payment_provider?: {
    provider: 'stripe_connect' | 'paypal' | 'paypal_subscriptions' | null;
    account_id: string | null;
    connected: boolean;
    client_token?: string | null;
  };
  stripe: {
    account_id: string;
    connected: boolean;
  };
  branding: {
    company_name: string | null;
    cache_icon: string;
    cache_icon_big: string;
    cache_text: string | null;
    cache_color: string;
    contact_email?: string;
    phone_number?: string;
    support_info_message?: string;
    whatsapp_number?: string;
    whatsapp_message?: string;
    terms_and_conditions_link?: string;
    privacy_policy?: string;
    require_tos_consent?: boolean;
    dashboard_language?: string;
    google_analytics_id?: string;
    google_client_id?: string;
  };
  meta: {
    timestamp: string;
    timezone: string;
    environment: string;
  };
}

export class LoadCompanyInfo implements Action {
  readonly type: string = LOAD_COMPANY_INFO;

  constructor(public payload?: any) {}
}

export class LoadCompanyInfoSuccess implements Action {
  readonly type: string = LOAD_COMPANY_INFO_SUCCESS;

  constructor(public payload: CompanyInfo) {}
}

export class LoadCompanyInfoFail implements Action {
  readonly type: string = LOAD_COMPANY_INFO_FAIL;

  constructor(public payload: any) {}
}

export type CompanyInfoActions =
  | LoadCompanyInfo
  | LoadCompanyInfoSuccess
  | LoadCompanyInfoFail;
